'use strict';

var _    = require('underscore');
var $    = require('jquery');
var Core = require('../core/core.js');
var Icons = require('../../../ui-icons/releases/bundle/rounded-bold-icons-bundle.js');

/**
 * Creates a LibraryRow
 *
 * @class
 */

class LibraryRow extends Core {

    _defaults() {
        return {
            target: '',
            fields: {
                'name': "",
                'icon': "",
                'summary': "",
                'description': "",
                'type': "",
                'has_children': false,
                'id': "",
                'version_number': "",
                'version_name': "",
                'user_name': "",
                'date_created': "",
                'thumb_url': "",
                'open_with_doubleclick': false
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__library__group'>
                <div class='editor__library__group__type__container'>
                    <div class='editor__library__group__collapseicon'>
                        <% if(has_children) { %>
                            <a class='editor__library__group__collapseicon__link'><%= embedded_svg('dropdown-triangle') %></a>
                        <% } %>
                    </div>

                    <div class='editor__library__group__type'>
                        <%= embedded_svg(icon) %>
                    </div>
                </div>

                <div class='editor__library__group__name'>
                    <div class='editor__library__group__field__text'><%- name %></div>
                </div>

                <div class='editor__library__group__summary'>
                    <div class='editor__library__group__field__text' title='<%- summary %>'><%- summary %></div>
                </div>

                <div class='editor__library__group__version'>
                    <div class='editor__library__group__field__text'><%- version_name %></div>
                    <div class='editor__library__group__asset__update'>
                        <a class='btn btn--s btn--none_level2_borders btn--hover--accent_none_accent'>
                            <div class="btn__txt">Update</div>
                        </a>
                    </div>
                </div>
                <div class='editor__library__group__date'>
                    <div class='editor__library__group__field__text'><%- date_created %></div>
                </div>
                <div class='editor__library__group__alert__info__container'>
                <div class='editor__library__group__alert__info'>
                    <a class='editor__library__group__alert__info__link'><%= embedded_svg('icon-warning') %></a>
                </div>
                <div class='editor__library__group__delete'>
                    <a class="btn btn--m js-pjax-link btn--none_level2_borders btn--hover--none_red_red js-are-you-sure js-delete">
                        <div class="btn__icon btn__icon--single"><%= embedded_svg('icon-trash') %></div>
                    </a>
                </div>
            </div>
            <div class='editor__library__group__child js-editor__library__group__child'></div>
        </div>`;

        super.render();

        this._groupOpened = false;

        //get parent asset type DOM offset. it is used to shift child asset type DOM in hierarchy
        this._assetTypeFieldOffset = parseFloat($('.editor__library__group__type__container:first').css('padding-left').replace(/[^-\d\.]/g, ''));

        //init DOM events
        this._initDOMEvents(options);

        // CLOSE BY DEFAULT
        this.close();
    }

    _initDOMEvents() {
        //asset collapse arrow
        $('.editor__library__group__collapseicon__link', this.$el).on('click', this._collapseClicked.bind(this));

        //asset row single click
        this.$el.on('click', this._clickAssetRow.bind(this));

        //asset row double click
        if(this._options.fields['open_with_doubleclick'])
            this.$el.on('dblclick', this._openAssetUrl.bind(this));

        //asset alert icon
        $('.editor__library__group__alert__info', this.$el).on('click', this._doNothing);

        //asset update button
        $('.editor__library__group__asset__update', this.$el).on('click', this._updateAsset.bind(this));

        //asset delete button
        $('.editor__library__group__delete', this.$el).on('click', this._removeAsset.bind(this));
    }

    _doNothing(e) {
        e.stopPropagation();
    }

    //TODO: should pass through state machine
    _collapseClicked(e){
        e.stopImmediatePropagation();

        if(!this._groupOpened) {
            this._groupOpened = true;
            this.open();
        } else {
            this._groupOpened = false;
            this.close();
        }
    }

    _openAssetUrl(e) {
        e.stopImmediatePropagation();
        //TODO: remove this response object
        $(e.currentTarget).trigger('Cioui:openAssetUrl', {
            id: this._options.fields['id'],
            type: this._options.fields['type'],
            versionNumber: this._options.fields['version_number']
        });
    }

    _updateAsset(e) {
        e.stopImmediatePropagation();
        //TODO: remove this response object
        $(e.currentTarget).trigger('Cioui:updateAsset', {
            id: this._options.fields['id'],
            type: this._options.fields['type'],
            versionNumber: this._options.fields['version_number']
        });
    }

    _clickAssetRow(e) {
        e.stopImmediatePropagation();
        //TODO: remove this response object
        this.$el.trigger('Cioui:assetClicked', {
            id: this._options.fields['id'],
            type: this._options.fields['type'],
            versionNumber: this._options.fields['version_number']
        });
    }

    _removeAsset(e) {
        e.stopImmediatePropagation();
        $(e.currentTarget).trigger('Cioui:assetRemove', {
            id: this._options.fields['id'],
            type: this._options.fields['type'],
            versionNumber: this._options.fields['version_number']
        });
    }

    addRow(asset){
        var libraryRow = new LibraryRow({
            target: $('.js-editor__library__group__child:first', this.$el),
            fields: {
                'name': asset.name,
                'icon': asset.icon,
                'summary': asset.summary,
                'type': asset.type,
                'has_children': asset.has_children,
                'id': asset.id,
                'version_number': asset.version_number,
                'version_name': asset.version_name,
                'user_name': asset.user_name,
                'date_created': asset.date_created,
                'thumb_url': asset.thumbnail,
                'open_with_doubleclick': asset.open_with_doubleclick
            }
        });

        //auto indentation of type icons in asset hierarchy
        libraryRow._assetTypeFieldOffset = this._assetTypeFieldOffset + 18;

        //apply to the first child of type container
        $(libraryRow.$el).children('.editor__library__group__type__container:first').children().first().css('padding-left', libraryRow._assetTypeFieldOffset + 'px');

        return libraryRow;
    }

    open(){
        $('.js-editor__library__group__child:first', this.$el).show();
        $('.editor__library__group__collapseicon:first', this.$el).removeClass("editor__library__group__collapseicon--closed");
    }

    close(){
        $('.js-editor__library__group__child:first', this.$el).hide();
        $('.editor__library__group__collapseicon:first', this.$el).addClass("editor__library__group__collapseicon--closed");
    }

    showUpdateButton(flag) {
        if(flag)
            $('.editor__library__group__asset__update:first', this.$el).addClass('editor__library__group__asset__update--show');
        else
            $('.editor__library__group__asset__update:first', this.$el).removeClass('editor__library__group__asset__update--show');
    }

    showRemoveButton(flag) {
        if(flag)
            $('.editor__library__group__delete:first', this.$el).addClass('editor__library__group__delete--show');
        else
            $('.editor__library__group__delete:first', this.$el).removeClass('editor__library__group__delete--show');
    }

    showAlertIconWithMessage(alertMessage) {
        $('.editor__library__group__alert__info:first', this.$el).addClass('editor__library__group__alert__info--show');
        $('.editor__library__group__alert__info__link:first svg', this.$el).trigger('Cioui:showAlertTooltip', alertMessage);
    }

    setSelected(){
        this.$el.addClass('editor__library__group__selected');
    }

    setUnselected(){
        this.$el.removeClass('editor__library__group__selected');
    }

    setReferenceStyle(flag) {
        if(flag)
            this.$el.addClass('editor__library__group__reference');
        else
            this.$el.removeClass('editor__library__group__reference');
    }
}

module.exports = LibraryRow;